import gql from "graphql-tag";

export const GetBrandDetails = gql`
  query GetBrandDetails($username: String) {
    accounts(username: $username) {
      id
      name
      bio
      preference {
        backgroundColor
        backgroundImage
        brandLogo
        programFeatures
        programHighlight
      }
      activeOpportunities {
        id
        product {
          id
          name
          price
          createdAt
          isDonation
          description
          images {
            id
            url
          }
        }
      }
    }
  }
`;
